
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./use-intersection-observer.cjs.production.min.js')
} else {
  module.exports = require('./use-intersection-observer.cjs.development.js')
}
